import { useTranslation } from "@fanfanlo";
import { Box, Button } from "@mui/material";
import Link from "next/link";
import { useRouter } from "next/router";

export function MarketsDevSettingsOpenLinkButton(){
    const router = useRouter();
    const {t} = useTranslation('homepage/components/page/markets-dev-settings/open-link-button/content');
    async function onClick(){
        const bl = await router.push("/markets-dev-settings");
    }
    return(
        <>
        <Button onClick={onClick} data-testid="MarketsDevSettingsOpenLinkButton__openButton__01JFQX8K9V" data-test-comment="打开市场开发设置页面按钮，点击后导航到市场开发设置页面">{t("content.name")}</Button>
        </>
    )
}

export function MarketsDevSettingsLineOpenLinkButton(){
    return(
        <>
            <Box sx={{mt:2, mb:2}}>
                <MarketsDevSettingsOpenLinkButton />
            </Box>
        </>
    )
}